import { Component, OnInit, ElementRef, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { Subscription } from 'rxjs';
import { remove, find as _find } from 'lodash';

import { NurseVisitService } from './nurse-visit.service';
import { MedicalServiceService } from '../medical-services/medical-service.service';
import { parseErrors } from '../shared/api.service';
import { NurseVisit } from './nurse-visit';
import { MedicalService } from '../medical-services/medical-service';

@Component({
  selector: 'nurse-visit-dialog',
  templateUrl: './nurse-visit-dialog.component.html',
  styleUrls: ['./nurse-visit-dialog.component.scss']
})
export class NurseVisitDialogComponent implements OnInit, OnDestroy {
  loading = false;
  costsAccepted = false;
  model: NurseVisit = new NurseVisit({});
  errors = [];
  medicalServices: MedicalService[] = [];
  callback: Function;

  nurseVisitReq: Subscription;
  medicalServicesReq: Subscription;

  constructor(
    public dialogRef: MatDialogRef<NurseVisitDialogComponent>,
    private elementRef: ElementRef,
    private nurseVisitService: NurseVisitService,
    private medicalServiceService: MedicalServiceService
  ) { }

  ngOnInit() {
    this.getMedicalServices();
  }

  ngOnDestroy() {
    if (this.medicalServicesReq) { this.medicalServicesReq.unsubscribe(); }
  }

  submit(): void {
    this.loading = true;
    if (this.nurseVisitReq) { this.nurseVisitReq.unsubscribe(); }
    this.nurseVisitReq = this.nurseVisitService.save(this.model).subscribe(nurseVisit => {
      this.loading = false;
      this.callback();
      this.dialogRef.close();
    }, err => {
      this.loading = false;
      this.errors = parseErrors(err);
    });
  }

  getMedicalServices(query = {}): void {
    if (this.medicalServicesReq) { this.medicalServicesReq.unsubscribe(); }
    this.medicalServicesReq = this.medicalServiceService.getMedicalServices({
      visit_id: this.model && this.model.visit
    }).subscribe(medicalServices => {
      this.medicalServices = medicalServices;
      this.loading = false;
    }, err => {
      this.loading = false;
      this.errors = parseErrors(err);
    });
  }

  selectMedicalService(medicalService: MedicalService, event): void {
    if (_find(this.model.services, { id: medicalService.id })) {
      remove(this.model.services, { id: medicalService.id });
    } else {
      this.model.services.push(medicalService);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/nurse-visits/nurse-visit-dialog.component.ts